import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { reducer } from './global-reducer';
import { initialGlobalState } from './global-state';
import { EffectsModule } from '@ngrx/effects';
import { GlobalEffects } from './global-effects';
import { GlobalsDataService } from '@core/data/api/global/global-data.service';
import { combineReducers } from '@core/utils/state';

@NgModule({
    imports: [
        HttpClientModule,
        StoreModule.forFeature(StateSlice.GLOBAL, (reducer as ActionReducer<any, any>), {
            initialState: initialGlobalState,
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ GlobalEffects ])
    ],
    declarations: [],
    providers: [
        GlobalsDataService
    ]
})
export class GlobalStateModule {}